import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appScrollScreenDirective]',
    standalone: true
})
export class ScrollScreenDirective {
    constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

    @HostListener('scroll') scrolling() {
        let top = 250;
        let hideOnTop = top;

        let openFlyOuts = document.body.querySelectorAll('.flyout-container');
        openFlyOuts.forEach((item: any, ind: any, key: any) => {
            let subTitleTooltipRef = item.querySelector('.sub-title-tooltip');
            if (subTitleTooltipRef.classList.contains('visible-longer')) {
                hideOnTop = 0;
            }
            // **********************
            // Display flyout

            if (
                subTitleTooltipRef.getBoundingClientRect().height >
                item.getBoundingClientRect().height
            ) {
                const height = item.getBoundingClientRect().height;
                subTitleTooltipRef.style.height =
                    (height > 400 ? height : 400) + 'px';
                if (ind != openFlyOuts.length - 1) {
                    subTitleTooltipRef.style.minHeight = '650px';
                }
            }

            if (ind == openFlyOuts.length - 2) {
                this.renderer.addClass(item, 'penultimate');
            }
            if (ind == openFlyOuts.length - 1) {
                this.renderer.addClass(item, 'last');
            }

            if (
                item.getBoundingClientRect().top <= top &&
                item.getBoundingClientRect().top >
                    item.getBoundingClientRect().height * -1 + hideOnTop
            ) {
                // this.renderer.addClass(item, 'visible');
                this.renderer.addClass(subTitleTooltipRef, 'display');
            } else {
                // this.renderer.removeClass(item, 'visible');
                this.renderer.removeClass(subTitleTooltipRef, 'display');
            }

            if (item.getBoundingClientRect().top < 0) {
                subTitleTooltipRef.style.top =
                    item.getBoundingClientRect().top * -1 + 20 + 'px';
            }
        });

        let element = this.elementRef.nativeElement;
        let penultimate = element.querySelector(
            '.flyout-container.penultimate'
        );
        let last = element.querySelector('.flyout-container.last');

        if (element.scrollHeight - element.scrollTop === element.clientHeight) {
            if (penultimate) {
                let tooltip1 = penultimate.querySelector('.sub-title-tooltip');
                this.renderer.removeClass(tooltip1, 'display');
            }
            if (last) {
                let tooltip2 = last.querySelector('.sub-title-tooltip');
                this.renderer.addClass(tooltip2, 'display');
            }
        }
    }
}
